import React from 'react'

const Footer = () => {
    return (
        <div style={{ textAlign: 'center', backgroundColor: 'white' }}>
        </div>
    )
}

export default Footer;